import { FunctionComponent, useCallback } from 'react'
import { useLogin } from '@dxp-module/login'
import { customEvent } from '@dxp-module/common'
import Signup from '../../../LoginOrSignup/components/Signup/Signup'
import { SignupFormSchema } from '../../../LoginOrSignup/model/SignupForm'
import { MyAccountEvents } from '../../../LoginOrSignup/enum/MyAccountEvents'
import miniWidgetSignupContainerStyles from './miniWidgetSignupContainer.styles'
import miniWidgetbuttonSubmitStyles from './miniWidgetButtonSubmit.styles'

type SignupContainerProps = {
  withoutRouter?: boolean
}
const SignupContainer: FunctionComponent<SignupContainerProps> = ({
  withoutRouter,
}) => {
  const styles = miniWidgetSignupContainerStyles({})
  const buttonSubmitStyles = miniWidgetbuttonSubmitStyles()

  const { login } = useLogin()

  const handleRegisterSuccess = useCallback(
    (_?: boolean | undefined, formData?: SignupFormSchema) => {
      if (formData) {
        login(formData.nameInfo.uniqueUserEmail, formData.nameInfo.password)
        customEvent.emit(MyAccountEvents.ON_SIGNUP_SUCCESS, true)
      }
    },
    [login]
  )

  return (
    <Signup
      classes={{ root: styles.root }}
      onRegisterSuccess={handleRegisterSuccess}
      buttonSubmitClasses={buttonSubmitStyles}
      withoutRouter={withoutRouter}
    />
  )
}

export default SignupContainer
